import { states } from '@department-of-veterans-affairs/platform-forms/address';
import { selectSchema } from '@department-of-veterans-affairs/platform-forms-system/web-component-patterns';

export const stateLabels = Object.fromEntries(
  states.USA.map(s => [s.value, s.label]),
);

export const stateSelectSchema = selectSchema(states.USA.map(s => s.value));
